module.exports = __webpack_public_path__ + "static/media/Einfach-Bequem1.a6349afe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Einfach-Bequem1.jpg
// module id = 232
// module chunks = 8